import { useEffect } from 'react';
import { ScanCommand } from '@aws-sdk/client-dynamodb';
import { unmarshall } from '@aws-sdk/util-dynamodb';
import { 
        Text, 
        Select, 
        Switch,
        FormControl,
        FormLabel,
        Link
    } from '@chakra-ui/react';



    function ViewerBoardSelector(props) {
     
    const { setBoard, boardList, setBoardList, setEditorMode, editorMode, client, definitionTable, signOut, admin } = props;
     
    const handleSelect = (selectedBoardID) => {
        setBoard(selectedBoardID);  
    };
    

    useEffect(() => {
        if(client && definitionTable){
            const fetchData = async () => {
              const command = new ScanCommand({
                TableName: definitionTable,
                ProjectionExpression: 'id, #n',
                ExpressionAttributeNames: { '#n': 'name' },
              });
            
              const response = await client.send(command);
              setBoardList(response.Items.map(item => unmarshall(item)));
            };
            
            fetchData();
        }
    }, [client, definitionTable, setBoardList]);
    
    
     

    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'start', padding: '2em', width: '100vw', height: '100vh'}}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'start', padding: '1em', width: '100%', height: '10%' }}>
                <img alt='Logo' src={process.env.PUBLIC_URL + "/images/one-nz-logo-black.png"} style={{height: '100%'}} />
            </div>
         <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'start', width: '100%', height: '90%' }}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'start', justifyContent: 'space-between', width: '50%', height: '50%' }}>
                <Text fontSize='5xl'> Wallboard Viewer </Text>
                { boardList ?
                    <>
                        <Text fontSize='2xl' style={{marginTop: '6em'}}> Select a board to view contact centre performance</Text>
                        <Select placeholder='Select a Board' onChange={(e) => handleSelect(e.target.value)}>
                            {boardList.map((board, itx) => {
                            return ( 
                                <option key={`slector-option-key-${itx}`} value={board.id}>{board.name}</option>
                            );
                            })}
                        </Select>
                    </> 
                :
                    <Text fontSize='2xl' style={{marginTop: '6em'}}> Fetching board list...</Text>
                }
            </div>
         </div>
        
         <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', minWidth: '100%'}}>
       
             <FormControl display='flex' alignItems='center'>
                <FormLabel htmlFor='mode' mb='0'>
                    Toggle edit mode
                </FormLabel>
              <Switch colorScheme='teal' id='mode' isChecked={editorMode} onChange={(e) => setEditorMode(e.target.checked)} />
            </FormControl>

             
            <Link style={{marginRight: '2em'}} onClick={signOut}> [LogOut] </Link>
        </div>
        
     </div>
     
    );
    
}

export default ViewerBoardSelector;